module.exports = __webpack_public_path__ + "static/media/focus.58278466.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程GLR增程式冷藏车/focus.png
// module id = 703
// module chunks = 0